export default __webpack_public_path__ + "static/media/dcine.a792108b.jpg";